import { useState } from 'preact/hooks';
export function useDialogState() {
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var onOpen = function () { return setIsOpen(true); };
    var onClose = function () { return setIsOpen(false); };
    return { isOpen: isOpen, onOpen: onOpen, onClose: onClose };
}
